const packageOpenButtons = document.querySelectorAll('button.package__link');

[...packageOpenButtons].forEach(openBtn => {
    const modalId = openBtn.getAttribute('data-modal-id');
    const modalEl = document.querySelector('#' + modalId);

    if (modalEl) {
        const formEl = modalEl.querySelector('form');
        const closeBtn = modalEl.querySelector('.package__close-modal');

        openBtn.addEventListener('click', () => {
            modalEl.removeAttribute('aria-hidden');
        });

        closeBtn.addEventListener('click', () => {
            modalEl.setAttribute('aria-hidden', 'true');
        });

        modalEl.addEventListener('click', () => {
            modalEl.setAttribute('aria-hidden', 'true');
        });

        formEl.addEventListener('click', e => {
            e.stopPropagation();
        });
    }
});
